export default "__VITE_ASSET__b7f6ee5a__"